module.exports = __webpack_public_path__ + "img/ass_result_icon_headBg.0c11c3f6.png";